"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SuperApp = require("./SuperApp");
Object.keys(_SuperApp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SuperApp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SuperApp[key];
    }
  });
});
